import Cookie from '@/helpers/cookie';

import { IBehavior } from '@/interfaces/Behavior';

export default {
  uuid: new Cookie({ name: 'COOKIE_EMP_UUID' }),
  checkoutLoaded: new Cookie({ name: 'COOKIE_EMP_CHECKOUT_LOADED' }),
  paymentMethodSelected: new Cookie({ name: 'COOKIE_EMP_PAYMENT_METHOD_SELECTED' }),
  offerSelected: new Cookie({ name: 'COOKIE_EMP_OFFER_SELECTED' }),
  priceSelected: new Cookie({ name: 'COOKIE_EMP_PRICE_SELECTED' }),
  purchaseResponse: new Cookie({ name: 'COOKIE_EMP_PURCHASE_RESPONSE' }),
  isCaptchaValid: true,
  isDeliveryAddressValid: true,
  ab: {
    segments: [
      {
        id: 'A',
        weight: 0.50,
        url: process.env.VUE_APP_APP_DOMAIN,
      },
      {
        id: 'B',
        weight: 0.50,
        url: process.env.VUE_APP_AB_TESTING_SEGMENT_B,
      },
    ],
  },
  canPay: true,
} as IBehavior;
